import React, { useState } from 'react';
import { useI18n } from '../i18n';
import { readDisplayOptions, saveDisplayOptions } from '../lib/displayOptions';

// "What columns would you like to show on this document?" — three switches,
// Cancel and Save. Julian's screenshot, in QPS's own type and palette.
//
// It edits a copy and only commits on Save, so Cancel really is a cancel:
// flicking three switches and then thinking better of it must leave the
// document exactly as it was.
//
// Used from both portals — the technician's estimate sheet and any document
// Julian or a customer opens — because a preference that only works in one of
// them is worse than not having it.

const Switch = ({ on, onChange, label }) => (
  <label className="dopt-row">
    <span className={`dopt-switch${on ? ' on' : ''}`}>
      <input
        type="checkbox"
        checked={on}
        onChange={e => onChange(e.target.checked)}
        // Visually hidden rather than display:none — Safari will not open or
        // toggle a display:none control from a label (see PROJECT-STATUS).
        style={{ position: 'absolute', opacity: 0, width: 1, height: 1 }}
      />
      <span className="dopt-knob"></span>
    </span>
    <span>{label}</span>
  </label>
);

export default function DisplayOptions({ open, onClose }) {
  const { t } = useI18n();
  const [draft, setDraft] = useState(readDisplayOptions);

  // Re-read whenever it opens: someone may have changed it on another sheet.
  const [wasOpen, setWasOpen] = useState(open);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) setDraft(readDisplayOptions());
  }
  if (!open) return null;

  return (
    <>
      <div className="modal active" style={{ zIndex: 320 }}>
        <div className="modal-box" style={{ maxWidth: 460 }}>
          <div className="modal-handle"></div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, marginBottom: 4 }}>{t('disp.title')}</div>
          <div style={{ fontSize: 13.5, color: 'var(--slate)', lineHeight: 1.5, margin: '10px 0 18px' }}>{t('disp.question')}</div>

          <Switch on={draft.rate} label={t('disp.rate')} onChange={v => setDraft(d => ({ ...d, rate: v }))} />
          <Switch on={draft.qty} label={t('disp.qty')} onChange={v => setDraft(d => ({ ...d, qty: v }))} />
          <Switch on={draft.itemTotals} label={t('disp.itemTotals')} onChange={v => setDraft(d => ({ ...d, itemTotals: v }))} />

          <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.5, margin: '14px 0 18px' }}>{t('disp.note')}</div>

          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-ghost btn-lg" onClick={onClose}>{t('req.cancel')}</button>
            <button className="btn btn-primary btn-lg" onClick={() => { saveDisplayOptions(draft); onClose(); }}>{t('ie.done')}</button>
          </div>
        </div>
      </div>
      <div className="overlay active" style={{ zIndex: 319 }} onClick={onClose}></div>
    </>
  );
}
